module.exports = __webpack_public_path__ + "img/company-auth-img.25c643e8.png";